import { gql } from '@apollo/client';

export const WARRANTY_RECORDS_LIST = gql`
  query WarrantyRecordsList {
    warrantyRecordsList {
      items {
        id
        warrantyNumber
        provider
        startDate
        endDate
        status
        vehicle { id unitNumber }
      }
    }
  }
`;

export const WARRANTY_RECORD_GET = gql`
  query WarrantyRecordGet($id: ID!) {
    warrantyRecord(id: $id) {
      id
      warrantyNumber
      provider
      startDate
      endDate
      status
      vehicle { id unitNumber }
    }
  }
`;

export const WARRANTY_RECORD_CREATE = gql`
  mutation WarrantyRecordCreate($data: WarrantyRecordCreateInput!) {
    warrantyRecordCreate(data: $data) {
      id
    }
  }
`;

export const WARRANTY_RECORD_UPDATE = gql`
  mutation WarrantyRecordUpdate($id: ID!, $data: WarrantyRecordUpdateInput!) {
    warrantyRecordUpdate(id: $id, data: $data) {
      id
    }
  }
`;

export const WARRANTY_RECORD_DELETE = gql`
  mutation WarrantyRecordDelete($id: ID!) {
    warrantyRecordDelete(id: $id) {
      success
    }
  }
`; 